import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import { MAX_TITLE_LENGTH } from '../../../../constants';
import { ArtsAndCraftsDeviationFieldName } from '../../types';

const TitleField: React.FC<{}> = () => {
  const { t } = useTranslation();
  const id = useId();
  const { control, formState } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name: ArtsAndCraftsDeviationFieldName.TITLE, control });
  const error = formState.errors[ArtsAndCraftsDeviationFieldName.TITLE];

  return (
    <TextInput
      id={id}
      maxLength={MAX_TITLE_LENGTH}
      label={t('artsAndCraftsDeviationPopup.form.title.label')}
      placeholder={t('artsAndCraftsDeviationPopup.form.title.placeholder')}
      value={value}
      onChange={onChange}
      details={error?.message as string | undefined}
      validationResult={error ? 'error' : undefined}
      autoFocus
      isRequired
      noBottomSpacing
    />
  );
};
TitleField.displayName = 'TitleField';

export default TitleField;
